<template>
  
    <div class="mt-6 px-4 py-5 text-center">
      <h1 class="text-3xl sm:text-4xl font-extralight">{{ message }}</h1>
    </div>
  
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: 'Teilnehmer nicht vorhanden.',
    },
  },
};
</script>